// @flow
import type { Untranslated } from '@rover/shared/js/types/Translation';
import type { ErrorContext } from '@rover/react-lib/types/ErrorContext';
import { captureException, withScope } from '@rover/utilities/sentry';

type StripeError = {| type: string, message: string, code: string |};
type ErrorType = Error | Untranslated | StripeError | {| id: string |};

function getErrorObject(error: ErrorType): Error {
  if (typeof error === 'string') {
    return new Error(error);
  } else if (error instanceof Error) {
    return error;

    // Special handling for Stripe SDK errors
    // they are thrown like errors, but are not
    // instances of the Error prototype
  } else if (
    typeof error.type === 'string' &&
    typeof error.message === 'string' &&
    typeof error.code === 'string'
  ) {
    return new Error(`${error.type}: ${error.code} - ${error.message}`);
  } else if (error.id) {
    return new Error(error.id);
  }
  return new Error(error);
}

const reportError = (error: ErrorType, errorContext?: ErrorContext) => {
  const errorObject: Error = getErrorObject(error);
  if (process.env.NODE_ENV === 'development') throw errorObject;

  withScope(scope => {
    scope.setExtras({ stacktrace: errorObject.stack });
    captureException(errorObject, errorContext);
  });
};

export default reportError;



// WEBPACK FOOTER //
// ../utilities/reportError.js